<template>
  <div>
    <sn-label
      v-if="label"
      class="mb-2"
      :title="label"
      :optional="showOptionalLabel"
    />
    <component
      :is="vuetifyComponent"
      v-bind="vuetifyOverrideMixin.bindings"
      class="sn-dropdowns"
      :data-cy="dataCy"
      v-on="$listeners"
    >
      <!-- Pass on all named slots -->
      <slot
        v-for="slot in Object.keys($slots)"
        :slot="slot"
        :name="slot"
      />

      <!-- Pass on all scoped slots -->
      <template
        v-for="slot in Object.keys($scopedSlots)"
        :slot="slot"
        slot-scope="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </component>
  </div>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'
import { cypressMixin } from '~/components/snui/v2/mixins/cypressMixin'
import SnLabel from '~/components/snui/v2/snLabel/snLabel'

export default {
  components: { SnLabel },
  mixins: [vuetifyOverrideMixin, cypressMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto',
          persistentHint: true
        },
        overriddenProps: {
          // Supported select, combobox, and autocomplete props
          /*
            autofocus: false,
            attach: false,
            chips: false,
            clearable: false,
            deletableChips: false,
            disabled: false,
            error: false,
            errorMessages: [],
            hideDetails: undefined,
            hint: undefined,
            itemText: text,
            itemValue: value,
            items: [],
            loading: false,
            multiple: false,
            noDataText: '$vuetify.noDataText',
            placeholder: undefined,
            returnObject: false, // Vuetify default for combobox is true
            rules: [],
            smallChips: false,
            validateOnBlur: false,
            value: undefined,
            valueComparator: (a: any, b: any): boolean,
          */

          // Supported combobox and autocomplete props
          /*
            allowOverflow: true,
            autoSelectFirst: false,
            filter: (_item, _queryText, _itemText) => {},
            hideNoData: false,
            noFilter: false,
            searchInput: undefined,
          */

          // Supported combobox props
          /*
            delimiters: [],
          */

          appendIcon: this.hideIcon ? '' : '$snChevronDown', // Vuetify's default is '$dropdown'
          appendOuterIcon: undefined,
          auto: true,
          autocomplete: false,
          backgroundColor: undefined,
          cacheItems: false,
          clearIcon: '$snExit', // Vuetify default is '$clear'
          color: 'snBrand', // Vuetify default is undefined
          counter: undefined,
          counterValue: null,
          dark: false,
          dense: false,
          disableLookup: false,
          eager: false,
          errorCount: 1,
          filled: false,
          flat: false,
          fullWidth: false,
          height: undefined,
          hideSelected: false,
          hideSpinButtons: false,
          id: undefined,
          itemColor: 'snPrimary', // Vuetify default is 'primary'
          itemDisabled: this.disabled,
          label: undefined,
          light: false,
          loaderHeight: 2,
          menuProps: {
            closeOnClick: false,
            closeOnContentClick: false,
            disableKeys: true,
            openOnClick: false,
            maxHeight: 304,
            // Added these to Vuetify's default menu props:
            offsetY: true,
            offsetOverflow: true,
            transition: false,
            contentClass: 'v-menu__content--sn-override'
          },
          messages: [],
          openOnClear: false,
          outlined: false,
          persistentPlaceholder: false,
          prefix: undefined,
          prependIcon: undefined,
          prependInnerIcon: undefined,
          readonly: false,
          reverse: false,
          rounded: false,
          shaped: false,
          singleLine: false,
          solo: false,
          soloInverted: false,
          success: false,
          successMessages: [],
          suffix: undefined,
          type: 'text'
        }
      }
    }
  }
}
</script>

<style lang="scss">
  // This is necessary so that we import the .v-menu__content--sn-override class referenced as one of the menu props above
  @import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';
</style>

<style lang="scss" scoped>
  @import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

  .sn-dropdowns {
    @extend .v-select--sn_override;
  }
</style>
